import {getReportParams, report} from '../../../middleware/report';

export function getDwhParams(state) {
  //DWH
  let channel =
    state.epiStyleInitializationData.businessIndividualLobby || (state.activeLobbyTab && state.activeLobbyTab == 'businessAccount')
      ? 'WebsiteBusiness'
      : 'WebsitePrivate';
  let param1 = state.isJETAuthentication ? 'JET' : 'WEBSITE';
  let param4 = state.selectedAbroadPackage?.isFamilyBonus ? 'מספר מנוי ראשי - ' + state.otpData.otpPhone : '';
  let param3 = '';
  if (state.selectedAbroadPackage?.isFamilyBonus) {
    param3 = 'בני משפחות';
  } else if (state.otpData.validatedCostumerData?.isSeparatedSale) {
    param3 = 'מכר בהפרדה';
  } else if (state.epiStyleInitializationData.businessIndividualLobby) {
    param3 = 'Individual';
  }
  const param5 = state.selectedCountries?.map((country) => country.countryCode).join(',');
  const param6 = state.dates?.selectedStartDate;
  const param7 = state.dates?.selectedEndDate;
  let subscriber = state.otpDataChildren?.otpPhone ? state.otpDataChildren.otpPhone : state.otpData?.otpPhone ? state.otpData.otpPhone : '';
  return {channel, param1, param4, param3, param5, param6, param7, subscriber};
}

export function dwhSelectAccountBusinessIndividualReport(phone, msg) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Abroad Business Individual Choose Subscriber';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Abroad Business Individual Choose Subscriber';
  reportParams.subscriber = '';
  reportParams.param1 = 'WEBSITE';
  reportParams.param3 = 'Individual';
  reportParams.param4 = phone;
  if (msg) {
    reportParams.param5 = msg;
  }
  report(reportParams);
}

export function errorOnOTPStep1(phone, param3) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'OTP';
  reportParams.status = 'Error';
  reportParams.messageText = 'OTP Step1 - General Error';
  reportParams.subscriber = phone;
  reportParams.param1 = 'WEBSITE/JET';
  reportParams.param3 = param3;
  report(reportParams);
}

export function dwhSetSelectedAbroadPackage({channel, subscriber, param1, param2, param3, param4, param5, param6, param7}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.actionType = 'Chose Package';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Client clicked "Purchase"';
  reportParams.subscriber = subscriber;
  reportParams.param1 = param1;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param4 = param4;
  reportParams.param5 = param5;
  reportParams.param6 = param6;
  reportParams.param7 = param7;
  report(reportParams);
}

export function dwhSetSelectedCountries({channel, subscriber, param1, param4, param3, param5, param6, param7}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.actionType = 'Search Parameters';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Countries Chosen';
  reportParams.subscriber = subscriber;
  reportParams.param1 = param1;
  reportParams.param4 = param4;
  reportParams.param3 = param3;
  reportParams.param5 = param5;
  reportParams.param6 = param6;
  reportParams.param7 = param7;

  report(reportParams);
}

export function dwhSetSelectedDates({channel, subscriber, param1, param4, param3, param5, param6, param7}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.actionType = 'Search Parameters';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Dates Chosen';
  reportParams.subscriber = subscriber;
  reportParams.param1 = param1;
  reportParams.param4 = param4;
  reportParams.param3 = param3;
  reportParams.param5 = param5;
  reportParams.param6 = param6;
  reportParams.param7 = param7;

  report(reportParams);
}

export function dwhAutoPackagePopupBusinessIndividual() {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Automatic package shown';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Automatic package shown';
  reportParams.subscriber = '';
  reportParams.param3 = 'Individual';

  report(reportParams);
}

export function dwhRoamPopupBusinessIndividual() {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Roaming soc not installed';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Roaming soc not installed';
  reportParams.subscriber = '';
  reportParams.param3 = 'Individual';

  report(reportParams);
}
export function dwhDataUsageBlockedPopupBusinessIndividual() {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Surf block exists';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Surf block exists';
  reportParams.subscriber = '';
  reportParams.param3 = 'Individual';

  report(reportParams);
}

export function dwhPackageSearchActivation({channel, subscriber, message, param1, param2, param3, param4, param5, param6, param7}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.actionType = 'Package search activation';
  reportParams.status = 'Ongoing';
  reportParams.messageText = message;
  reportParams.subscriber = subscriber;
  reportParams.param1 = param1;
  reportParams.param2 = param2 || '';
  reportParams.param3 = param3 || '';
  reportParams.param4 = param4 || '';
  reportParams.param5 = param5 || '';
  reportParams.param6 = param6 || '';
  reportParams.param7 = param7 || '';
  report(reportParams);
}

export function dwhValidateCustomer({channel, subscriber, param1, param4, param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.actionType = 'OTP';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'OTP step 2 in abroad';
  reportParams.param1 = param1;
  reportParams.param4 = param4;
  reportParams.param3 = param3 || '';
  reportParams.subscriber = subscriber;
  report(reportParams);
}

export function dwhErrorValidateCustomer({channel, subscriber, param1, param4, param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.actionType = 'OTP';
  reportParams.status = 'Error';
  reportParams.messageText = 'Getting customer data - General Error';
  reportParams.param1 = param1;
  reportParams.param4 = param4;
  reportParams.param3 = param3 || '';
  reportParams.subscriber = subscriber;
  report(reportParams);
}

export function dwhGettingCustomerAbroadPackages({channel, subscriber, param1, param4, param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.actionType = 'OTP';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'OTP step 2 in abroad';
  reportParams.param1 = param1;
  reportParams.param4 = param4;
  reportParams.param3 = param3 || '';
  reportParams.subscriber = subscriber;

  report(reportParams);
}

export function dwhAbroadAddonsSuccessPage({channel, message, param1, param2, param3, param4, param5, customerName, idNumber, subscriber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.actionType = 'Abroad Success Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = message;
  reportParams.param1 = param1;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param4 = param4;
  reportParams.param5 = param5;
  reportParams.customerName = customerName;
  reportParams.ban = '';
  reportParams.idNumber = idNumber;
  reportParams.subscriber = subscriber;

  report(reportParams);
}
export function dwhAbroadAddonsPopup({
  channel,
  message,
  status,
  param1,
  param2,
  param3,
  param4,
  param5,
  customerName,
  idNumber,
  subscriber,
}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.actionType = 'Addon PopUp';
  reportParams.status = status;
  reportParams.messageText = message;
  reportParams.param1 = param1;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param4 = param4;
  reportParams.param5 = param5;
  reportParams.customerName = customerName;
  reportParams.idNumber = idNumber;
  reportParams.subscriber = subscriber;
  reportParams.ban = '';
  report(reportParams);
}

export function dwhRemoveAbroadAddon({
  channel,
  message,
  status,
  param1,
  param2,
  param3,
  param4,
  param5,
  customerName,
  idNumber,
  subscriber,
}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.actionType = 'Cancel PopUp';
  reportParams.status = status;
  reportParams.messageText = message;
  reportParams.param1 = param1;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param4 = param4;
  reportParams.param5 = param5;
  reportParams.customerName = customerName;
  reportParams.ban = '';
  reportParams.idNumber = idNumber;
  reportParams.subscriber = subscriber;
  report(reportParams);
}

export function dwhRemoveAbroadAddonSameDay({
  channel,
  message,
  status,
  param1,
  param2,
  param4,
  param5,
  customerName,
  idNumber,
  subscriber,
}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.actionType = 'packages cancel package';
  reportParams.status = status;
  reportParams.messageText = message;
  reportParams.param1 = param1;
  reportParams.param2 = param2;
  reportParams.param3 = 'sameday cancel';
  reportParams.param4 = param4;
  reportParams.param5 = param5;
  reportParams.customerName = customerName;
  reportParams.ban = '';
  reportParams.idNumber = idNumber;
  reportParams.subscriber = subscriber;
  report(reportParams);
}

export function dwhAbroadAddonExistingPage({channel, message, param1, param2, param3, param4, param5, customerName, idNumber, subscriber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.actionType = 'Package Exists Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = message;
  reportParams.param1 = param1;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param4 = param4;
  reportParams.param5 = param5;
  reportParams.customerName = customerName;
  reportParams.ban = '';
  reportParams.idNumber = idNumber;
  reportParams.subscriber = subscriber;

  report(reportParams);
}

export function dwhAbroadAddonPackagePage({channel, message, param1, param2, actionType, customerName, idNumber, subscriber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellcom Abroad';
  reportParams.channel = channel;
  reportParams.actionType = actionType;
  reportParams.status = 'Ongoing';
  reportParams.messageText = message;
  reportParams.param1 = param1;
  reportParams.param2 = param2 || '';
  reportParams.customerName = customerName;
  reportParams.ban = '';
  reportParams.idNumber = idNumber;
  reportParams.subscriber = subscriber;
  report(reportParams);
}
